import tw from "tailwind-styled-components";

export const StatusConstainer = tw.div`
group flex justify-center items-center
`;

export const StatusColorContainer = tw.div`
flex gap-2 justify-center 
hover:cursor-pointer
`;

export const ToolTipMsg = tw.div`
max-w-28 p-1 mt-14 z-50 bg-gray-50
text-[8px] text-center text-black 
rounded-md shadow-sm 
absolute group-hover:visible
`;

export const SuccessObservation = tw.div`
flex gap-2 justify-start
`;

export const ErrorObservation = tw.div`
group flex justify-start
`;

export const ErrorObservationIcon = tw.div`
flex gap-2 justify-center hover:cursor-pointer
`;

export const ErrorObservationTooltip = tw.div`
bg-gray-50 p-2 mt-5 z-20
text-xs text-black
rounded-lg shadow-lg
absolute group-hover:visible  
`;

export const ErrorsObservationList = tw.ul`
text-[8px] list-disc list-inside text-start
`;

export const ListContainer = tw.div`
max-w-7xl w-full h-full 
flex flex-col m-5 gap-5 relative
`;

export const NavbarListContainer = tw.div`
flex items-center justify-between bg-white
`;

export const Path = tw.div`
font-Roboto font-semibold 
text-sm text-gray-400
`;

export const Container1 = tw.div`
flex flex-col gap-3
`;

export const NavbarTitle = tw.h1`
font-bold text-[#0052A2] text-xl
`;

export const ExcelButtonsContainer = tw.div`
flex gap-3 items-center ml-10
`;

export const ButtonsContainer = tw.div`
flex gap-5 items-center
`;

export const TableContainer = tw.div`
w-full pb-5  overflow-auto
`;

export const CheckboxContainer = tw.div`
flex items-center justify-center
`;

export const CheckboxAllMsjContainer = tw.div`
text-xs text-black 
bg-gray-100 shadow-lg group-hover:visible  
absolute z-50 p-1.5 rounded-md ml-6
`;

export const CheckboxAllMsj = tw.p`
text-[10px] text-start font-Roboto font-normal text-gray-800
`;
